import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  folders: [],
  isDeleted: false,
  folder: {},
};
const FolderSlice = createSlice({
  name: 'FolderSlice',
  initialState,
  reducers: {
    loadFolders: (state, action) => {
      state.folders = [...action.payload];
    },
    createFolderSuccess: (state, action) => {
      state.folders.push(action.payload);
      state.folder = action.payload;
    },
    folderDeleteSuccess: (state, action) => {
      state.folders = state.folders.filter(p => p._id !== action.payload);
      state.isDeleted = true;
    },
  },
});
export default FolderSlice.reducer;
export const { loadFolders, createFolderSuccess, folderDeleteSuccess } =
  FolderSlice.actions;
